import { AlertCircleIcon } from "@hugeicons-pro/core-stroke-rounded";
import { HugeiconsIcon } from "@hugeicons/react";
import { Show } from "shared/components";

export const DocumentIssueAlert = ({
  label,
  description
}: {
  label: string;
  description?: string;
}) => (
  <div className="flex w-full flex-col justify-center gap-4 overflow-hidden rounded-lg border border-alpha-100 bg-warning-50 p-4 shadow-xs">
    <div className="flex w-full items-start gap-3">
      <div className="flex shrink-0 items-center pt-0.5">
        <HugeiconsIcon
          icon={AlertCircleIcon}
          size={20}
          strokeWidth={1.5}
          className="text-warning-500"
        />
      </div>

      <div className="flex flex-1 flex-col justify-center gap-1">
        <p className="text-base font-bold leading-6 text-content-1000">
          {label}
        </p>
        <Show if={Boolean(description)}>
          <p className="text-sm font-medium leading-5 text-content-500">
            {description}
          </p>
        </Show>
      </div>
    </div>
  </div>
);
